import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Styles from "../Style/Common.module.css";
import Loader from "../Common/PageLoader/LoadingSpinner";

import axios from "axios";
import parse from "html-react-parser";
import ReCAPTCHA from "react-google-recaptcha";

import constants from "../../services/constants";
import { getTQAddressAPI, getCsrfToken } from "../../services/routes.services";

import { IoLocationOutline } from "react-icons/io5";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { GoMail } from "react-icons/go";

import { validateField, validateForm } from "../../utils/validation";

const ContactUs = () => {
  //const SITE_KEY = "6LdU_wwtAAAAAJNGIwehssgZxrIp8_EBfucyIYbT";
  const SITE_KEY = "6LdEPpAtAAAAABX25uZYK03eg6iFdas84gYKfICw";

  const [loading, setLoading] = useState(true);

  const [submitting, setSubmitting] = useState(false);

  const [csrfToken, setCsrfToken] = useState("");

  const [captchaValue, setCaptchaValue] = useState("");

  const [response, setResponse] = useState(null);

  const [error, setError] = useState("");

  const [addressData, setAddressData] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    organization: "",
    email: "",
    phoneNumber: "",
    query: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    title: "",
    organization: "",
    email: "",
    phoneNumber: "",
    query: "",
    city: "",
    message: "",
  });

  const [touched, setTouched] = useState({
    title: false,
    organization: false,
    email: false,
    phoneNumber: false,
    query: false,
    city: false,
    message: false,
  });

  useEffect(() => {
    fetchLinks();
    getCsurfToken();
  }, []);
  const getCsurfToken = async () => {
    try {
      const response = await getCsrfToken();
      setCsrfToken(response.data.csrfToken);
    } catch (err) {
      console.log(err);
    }
  };
  const fetchLinks = async () => {
    try {
      const response = await getTQAddressAPI("Contact");

      setAddressData(response.data.addresses || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  const normalizeValue = (value) => {
    return value.replace(/\s+/g, " ");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let newValue = normalizeValue(value);

    switch (name) {
      case "title":
        newValue = newValue.replace(/[^A-Za-z\s'-]/g, "");

        break;

      case "city":
        newValue = newValue.replace(/[^A-Za-z\s'-]/g, "");

        break;

      case "phoneNumber":
        newValue = newValue.replace(/\D/g, "").slice(0, 10);

        break;

      default:
        break;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));

    if (touched[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: validateField(name, newValue),
      }));
    }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;

    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
  };
  const validateBeforeSubmit = () => {
    const validationErrors = validateForm(formData);

    setErrors(validationErrors);

    setTouched({
      title: true,
      organization: true,
      email: true,
      phoneNumber: true,
      query: true,
      city: true,
      message: true,
    });

    return Object.keys(validationErrors).length === 0;
  };

  const hasErrors = () => {
    return Object.values(errors).some((error) => error !== "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setResponse(null);
    setError("");

    // Validate all fields
    if (!validateBeforeSubmit()) {
      return;
    }

    // Validate reCAPTCHA
    if (!captchaValue) {
      setError("Please verify that you are not a robot.");
      return;
    }

    setSubmitting(true);

    try {
      // Trim all values before sending
      const payload = {
        title: formData.title.trim(),
        organization: formData.organization.trim(),
        email: formData.email.trim().toLowerCase(),
        phoneNumber: formData.phoneNumber.trim(),
        query: formData.query.trim(),
        city: formData.city.trim(),
        message: formData.message.trim(),
        captchaToken: captchaValue,
      };

      const res = await axios.post(
        `${constants.API_BASE_URL}contactus`,
        payload,
        {
          headers: {
            "X-CSRF-Token": csrfToken,
            "Content-Type": "application/json",
          },
        },
      );

      setResponse(res.data);

      // Reset Form
      setFormData({
        title: "",
        organization: "",
        email: "",
        phoneNumber: "",
        query: "",
        city: "",
        message: "",
      });

      // Clear Errors
      setErrors({
        title: "",
        organization: "",
        email: "",
        phoneNumber: "",
        query: "",
        city: "",
        message: "",
      });

      // Reset touched state
      setTouched({
        title: false,
        organization: false,
        email: false,
        phoneNumber: false,
        query: false,
        city: false,
        message: false,
      });

      // Reset Captcha
      setCaptchaValue("");
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Something went wrong. Please try again.");
      }

      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const corporateAddress = addressData
    .filter((item) =>
      ["Corporate Address", "Registered Address"].includes(item.title),
    )
    .sort((a, b) => a.order - b.order); // Sort by 'order' in ascending order
  const otherAddresses = addressData
    .filter((item) => item.title === "Other Operating Locations")
    .sort((a, b) => a.order - b.order); // Sort by 'order' in ascending order
  const foreginAddress = addressData
    .filter((item) => item.title === "Foreign Branch Offices")
    .sort((a, b) => a.order - b.order); // Sort by 'order' in ascending order

  const branchAddress = addressData
    .filter((item) => item.title === "Branch Office")
    .sort((a, b) => a.order - b.order); // Sort by 'order' in ascending order

  const SubsidiariesAddress = addressData
    .filter((item) => ["Subsidiary Office", "JV Office"].includes(item.title))
    .sort((a, b) => a.order - b.order); // Sort by 'order' in ascending order

  return (
    <div className={`directorsPage ${Styles.boardPage}`}>
      <div
        className={`${Styles.innerBanner} ${Styles.InnerSmallBanner} ${Styles.noneMask} ${Styles.smallBanner}`}
      >
        <img
          src={require("../../assest/images/blog-banner.jpg")}
          className={Styles.innerBannerimg}
          alt="Banner"
        />
        <div className={Styles.innerBannerContent}>
          <Container>
            <Row>
              <Col>
                <div className={Styles.detail}>
                  <h2>Get in touch</h2>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className={Styles.contactForm}>
        <Container>
          <Row>
            <Col>
              <div className={Styles.FormContainer}>
                <h4>Send us a message</h4>
                {error && <p className={Styles.error}>{error}</p>}
                {response && (
                  <p className={Styles.success}>
                    Thank you! We'll get in touch with you soon.
                  </p>
                )}
                <form onSubmit={handleSubmit} noValidate>
                  <div className={Styles.fromElem}>
                    {/* ================= Name & Organization ================= */}

                    <div className={Styles.formGroup}>
                      <div className={Styles.group}>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          placeholder="Name *"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          maxLength={50}
                          autoComplete="off"
                          spellCheck={false}
                        />

                        {errors.title && (
                          <p className={Styles.error}>{errors.title}</p>
                        )}
                      </div>

                      <div className={Styles.group}>
                        <input
                          type="text"
                          id="organization"
                          name="organization"
                          value={formData.organization}
                          placeholder="Organization *"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          maxLength={100}
                          autoComplete="off"
                          spellCheck={false}
                        />

                        {errors.organization && (
                          <p className={Styles.error}>{errors.organization}</p>
                        )}
                      </div>
                    </div>

                    {/* ================= Email & Phone ================= */}

                    <div className={Styles.formGroup}>
                      <div className={Styles.group}>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          placeholder="Email Address *"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          maxLength={100}
                          autoComplete="off"
                          spellCheck={false}
                        />

                        {errors.email && (
                          <p className={Styles.error}>{errors.email}</p>
                        )}
                      </div>

                      <div className={Styles.group}>
                        <input
                          type="text"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          placeholder="Phone Number *"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          inputMode="numeric"
                          maxLength={10}
                          autoComplete="off"
                          spellCheck={false}
                        />

                        {errors.phoneNumber && (
                          <p className={Styles.error}>{errors.phoneNumber}</p>
                        )}
                      </div>
                    </div>

                    {/* ================= Query & City ================= */}

                    <div className={Styles.formGroup}>
                      <div className={Styles.group}>
                        <input
                          type="text"
                          id="query"
                          name="query"
                          value={formData.query}
                          placeholder="What is your query about? *"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          maxLength={100}
                          autoComplete="off"
                          spellCheck={false}
                        />

                        {errors.query && (
                          <p className={Styles.error}>{errors.query}</p>
                        )}
                      </div>

                      <div className={Styles.group}>
                        <input
                          type="text"
                          id="city"
                          name="city"
                          value={formData.city}
                          placeholder="City *"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          maxLength={50}
                          autoComplete="off"
                          spellCheck={false}
                        />

                        {errors.city && (
                          <p className={Styles.error}>{errors.city}</p>
                        )}
                      </div>
                    </div>

                    {/* ================= Message ================= */}

                    <div className={Styles.formGroup}>
                      <div className={Styles.group}>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          placeholder="Message *"
                          rows={5}
                          maxLength={1000}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          spellCheck={false}
                        />

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: 5,
                          }}
                        >
                          {errors.message ? (
                            <p className={Styles.error}>{errors.message}</p>
                          ) : (
                            <span />
                          )}

                          <small>{formData.message.length}/1000</small>
                        </div>
                      </div>
                    </div>

                    {/* ================= reCAPTCHA ================= */}

                    <div className={Styles.formGroup}>
                      <ReCAPTCHA
                        sitekey={SITE_KEY}
                        onChange={(value) => {
                          setCaptchaValue(value);
                          setError("");
                        }}
                        onExpired={() => {
                          setCaptchaValue("");
                        }}
                      />

                      {!captchaValue && touched.message && (
                        <p className={Styles.error}>
                          Please verify that you are not a robot.
                        </p>
                      )}
                    </div>

                    {/* ================= Success / Error ================= */}

                    {/* {response && (
                      <div className={Styles.success}>
                        Thank you! Your enquiry has been submitted successfully.
                      </div>
                    )} */}

                    {error && <div className={Styles.error}>{error}</div>}

                    {/* ================= Submit ================= */}

                    <div className={Styles.formGroup}>
                      <button
                        type="submit"
                        className={Styles.submitButton}
                        disabled={submitting || hasErrors()}
                      >
                        {submitting ? <Loader /> : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className={Styles.TQMap}>
        <div className={Styles.TQMapContainer}>
          <div className={Styles.addressBg}>
            <Container>
              <Row>
                <Col
                  className={
                    Styles.centerAlight +
                    " " +
                    Styles.addressList +
                    " " +
                    Styles.titleAddres
                  }
                >
                  <h5>TQ Cert Services Private Limited </h5>
                </Col>
              </Row>
              {/* <Row>
                                
                                <Col className={Styles.TQMapAddress}>
                                    <div className={Styles.addressList}>
                                        {/* <h5>{item.city}</h5> */}
              {/* <h6>Registered Address - Hyderabad</h6>
                                        <ul>
                                            <li><span className={Styles.icon}><IoLocationOutline /></span>Room No 3, Fourth Floor, Mithona Towers-1 1-7-80 to 87, Prender Ghast Road, Hyderabad, Secunderabad, Telangana, India, 500003</li>                                            
                                            <li><span className={Styles.icon}><GoMail /></span>cstpl@tataprojects.com</li>
                                            <li><span className={Styles.icon}><LiaPhoneVolumeSolid /></span>+91-40-66238801</li>
                                            <li><span className={Styles.cinIcon}>CIN</span>U74220TG2003PTC040523</li>
                                        </ul>
                                    </div> */}

              {/* </Col>
                            </Row> */}
              {corporateAddress && corporateAddress.length !== 0 && (
                <Container>
                  <Row>
                    {/* <Col className={Styles.centerAlight+" "+ Styles.addressList +" "+ Styles.addresshedingList}><h5>Corporate Office </h5></Col></Row> */}

                    <Col className={Styles.TQMapAddress}>
                      {corporateAddress.map((item) => {
                        return (
                          <div className={Styles.addressList} key={item._id}>
                            {/* <h5>{item.city}</h5> */}
                            <h6 className={Styles.centerAlight}>
                              {" "}
                              {item.city}
                            </h6>
                            <ul>
                              <li>
                                <span className={Styles.icon}>
                                  <IoLocationOutline />
                                </span>
                                {parse(`${item.addressName}`)}
                              </li>

                              {item.email && (
                                <li>
                                  <span className={Styles.icon}>
                                    <GoMail />
                                  </span>
                                  {item.email}
                                </li>
                              )}
                              {item.phoneNumber !== "1" && (
                                <li>
                                  <span className={Styles.icon}>
                                    <LiaPhoneVolumeSolid />
                                  </span>
                                  {item.phoneNumber}
                                </li>
                              )}
                              {item.title === "Registered Address" && (
                                <li>
                                  <span className={Styles.cinIcon}>CIN</span>
                                  U74220TG2003PTC040523
                                </li>
                              )}
                            </ul>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </Container>
              )}
              {branchAddress && branchAddress.length !== 0 && (
                <Container>
                  <Row>
                    <Col
                      className={
                        Styles.centerAlight +
                        " " +
                        Styles.addressList +
                        " " +
                        Styles.addresshedingList
                      }
                    >
                      <h5>Branch Offices </h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col className={Styles.TQMapAddress}>
                      {branchAddress.map((item) => {
                        return (
                          <div className={Styles.addressList} key={item._id}>
                            {/* <h5>{item.city}</h5> */}
                            <h6 className={Styles.centerAlight}>
                              {" "}
                              {item.city}
                            </h6>
                            <ul>
                              <li>
                                <span className={Styles.icon}>
                                  <IoLocationOutline />
                                </span>
                                {parse(`${item.addressName}`)}
                              </li>

                              {item.email && (
                                <li>
                                  <span className={Styles.icon}>
                                    <GoMail />
                                  </span>
                                  {item.email}
                                </li>
                              )}
                              {item.phoneNumber !== "1" && (
                                <li>
                                  <span className={Styles.icon}>
                                    <LiaPhoneVolumeSolid />
                                  </span>
                                  {item.phoneNumber}
                                </li>
                              )}
                            </ul>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </Container>
              )}
              {otherAddresses && otherAddresses.length !== 0 && (
                <Container>
                  <Row>
                    <Col
                      className={
                        Styles.centerAlight +
                        " " +
                        Styles.addressList +
                        " " +
                        Styles.addresshedingList
                      }
                    >
                      <h5>Other Operating Locations</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col className={Styles.TQMapAddress}>
                      {otherAddresses.map((item) => {
                        return (
                          <div className={Styles.addressList} key={item._id}>
                            {/* <h5>{item.city}</h5> */}
                            <h6 className={Styles.centerAlight}>
                              {" "}
                              {item.city}
                            </h6>
                            <ul>
                              {/* <li><span className={Styles.icon}><IoLocationOutline /></span>{parse(`${item.addressName}`)}</li> */}

                              {item.email && (
                                <li>
                                  <span className={Styles.icon}>
                                    <GoMail />
                                  </span>
                                  {item.email}
                                </li>
                              )}
                              {item.phoneNumber !== "1" && (
                                <li>
                                  <span className={Styles.icon}>
                                    <LiaPhoneVolumeSolid />
                                  </span>
                                  {item.phoneNumber}
                                </li>
                              )}
                            </ul>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </Container>
              )}
              {foreginAddress && foreginAddress.length !== 0 && (
                <Container>
                  <Row>
                    <Col
                      className={
                        Styles.centerAlight +
                        " " +
                        Styles.addressList +
                        " " +
                        Styles.addresshedingList
                      }
                    >
                      <h5>Foreign Branch Offices</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col className={Styles.TQMapAddress}>
                      {foreginAddress.map((item) => {
                        return (
                          <div className={Styles.addressList} key={item._id}>
                            {/* <h5>{item.city}</h5> */}
                            <h6 className={Styles.centerAlight}>
                              {" "}
                              {item.city}
                            </h6>
                            <ul>
                              <li>
                                <span className={Styles.icon}>
                                  <IoLocationOutline />
                                </span>
                                {parse(`${item.addressName}`)}
                              </li>

                              {item.email && (
                                <li>
                                  <span className={Styles.icon}>
                                    <GoMail />
                                  </span>
                                  {item.email}
                                </li>
                              )}
                              {item.phoneNumber !== "1" && (
                                <li>
                                  <span className={Styles.icon}>
                                    <LiaPhoneVolumeSolid />
                                  </span>
                                  {item.phoneNumber}
                                </li>
                              )}
                            </ul>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </Container>
              )}
              {SubsidiariesAddress && SubsidiariesAddress.length !== 0 && (
                <Container>
                  <Row>
                    <Col
                      className={
                        Styles.centerAlight +
                        " " +
                        Styles.addressList +
                        " " +
                        Styles.addresshedingList
                      }
                    >
                      <h5>Subsidiaries & JVs</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col className={Styles.TQMapAddress}>
                      {SubsidiariesAddress.map((item) => {
                        return (
                          <div className={Styles.addressList} key={item._id}>
                            {/* <h5>{item.city}</h5> */}
                            <h6 className={Styles.centerAlight}>
                              {" "}
                              {item.city}
                            </h6>
                            <ul>
                              <li>
                                <span className={Styles.icon}>
                                  <IoLocationOutline />
                                </span>
                                {parse(`${item.addressName}`)}
                              </li>

                              {item.email && (
                                <li>
                                  <span className={Styles.icon}>
                                    <GoMail />
                                  </span>
                                  {item.email}
                                </li>
                              )}
                              {item.phoneNumber !== "1" && (
                                <li>
                                  <span className={Styles.icon}>
                                    <LiaPhoneVolumeSolid />
                                  </span>
                                  {item.phoneNumber}
                                </li>
                              )}
                            </ul>
                          </div>
                        );
                      })}
                    </Col>
                  </Row>
                </Container>
              )}
            </Container>
          </div>
          {/* <div className={Styles.TQMapAddress}>
                            <div className={Styles.addressList}>
                                <h5>{addressData.city}</h5>
                                <h6>{addressData.title}</h6>
                                <ul>
                                    <li><span className={Styles.icon}><IoLocationOutline /></span>{addressData.addressName}</li>
                                    <li><span className={Styles.icon}><GoMail /></span>{addressData.email}</li>
                                    <li><span className={Styles.icon}><LiaPhoneVolumeSolid /></span>{addressData.phoneNumber}</li>
                                </ul>
                            </div>
                    </div> */}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
